exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.textSpan {\n  color: #495057;\n  font-size: 16px;\n  font-weight: 400; }\n\n.ConfirmOkButton {\n  padding: 0.65rem 2.13rem;\n  font-size: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/app/shared/confirmationModal/confirmationModal.component.scss
// module id = ../../../../../src/app/shared/confirmationModal/confirmationModal.component.scss
// module chunks = main